module.exports = __webpack_public_path__ + "img/PRO.ff4d2259.svg";